export default __webpack_public_path__ + "static/Frederikplein 47b, Amsterdam-3812f4a50b9890baaf9de9d60c17fda5.webp";